import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;
    max-width: 40rem;
`;

const Heading = styled.span`
    opacity: 0.75;
    font-weight: 500;
`;

const Message = styled.span`
    text-wrap: balance;
    text-align: center;
    font-size: 0.875rem;
    opacity: 0.75;
    line-height: 1.25rem;
`;

function InstagramTimeSeriesNoDataMessage() {
    return (
        <Wrapper>
            <Heading>Not enough data to construct time series.</Heading>
            <Message>
                Historical data for newly added hashtags will become available
                as new data points are collected each week.
            </Message>
        </Wrapper>
    );
}

export default InstagramTimeSeriesNoDataMessage;
